<svelte:head>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;500;600&display=swap" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap" rel="stylesheet">
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

    <title>{ import.meta.env.VITE_WEBSITE_TITLE }</title> <!-- eslint-disable-line -->
</svelte:head>

<script>
     
    import { firebase } from '$lib/firebase/firebase';
    import { Loader } from '@repo/ui';
    import './styles.css';
    import { onMount } from 'svelte';
    import { get } from 'svelte/store';
    import { getCurrentUser } from '$lib/Auth';
    import { jwtDecode } from 'jwt-decode';
    import { goto } from '$app/navigation';
    import { page } from '$app/state';
    /**
     * @typedef {Object} Props
     * @property {import('svelte').Snippet} [children]
     */
    let { children } = $props();

     
    firebase;

    onMount(async () => {
        const interval = setInterval(async () => {
            const user = get(getCurrentUser());
            if (user && page.route.id !== '/change-password') {
                const token = await user.getIdToken();
                const decodedToken = jwtDecode(token);
                const changePassword = decodedToken?.changePassword || false;
                if (changePassword) {
                    clearInterval(interval);
                    await goto('/change-password');
                }
            }
        }, 500);

        setTimeout(() => clearInterval(interval), 3000);
    });
</script>

<div class="biozone-world semi-interactive">
    {@render children?.()}
    <Loader />
</div>
